module.exports = __webpack_public_path__ + "static/fonts/iconfont.9e0f616.ttf";